import dateFormat from 'dateformat'

import planIndex from '@/assets/formats/index'
import spreadSheetsIndex from '@/assets/spreadSheets/index'

const SITE_URL = process.env.VUE_APP_SITE_URL

const planConfig = {
  install: function (Vue, options) {
    const main = new Vue({
      data: function () {
        return {}
      },
      computed: {
        companyFormatList: function () {
          return {
            corporation: '法人',
            freelance: '個人事業主'
          }
        },
        experienceStatusList: function () {
          return {
            inexperience: '事業を経営していたことはない',
            continuation: '事業を経営していたことがあり、現在もその事業を続けている',
            quit: '事業を経営していたことがあるが、既にその事業をやめている'
          }
        },
        genderList: function () {
          return {
            male: '男性',
            female: '女性',
            custom: 'カスタム'
          }
        },
        consultationKindList: function () {
          return {
            correction: 'webで相談',
            interview: '面談で相談'
          }
        },
        consultationRequestStatus: function () {
          return {
            applying: '申請中',
            //accepted: '承諾済み',
            //refuse: '辞退済み',
            accepted: '確認済み',
            refuse: '辞退済み'
          }
        },
        planIndex: () => {
          return planIndex
        },
        spreadSheetsIndex: () => {
          return spreadSheetsIndex
        }
      },
      mounted: function () {},
      methods: {
        needsAddingCard: function (itemId) {
          const addableCardIdList = [
            'president-info',
            'business-contents',
            'market-environment',
            'operation',
            'borrowing'
          ]
          if (addableCardIdList.indexOf(itemId) >= 0) {
            return true
          }
          return false
        },
        dateFormat: function (date, format = 'yyyy-m-d') {
          // https://github.com/felixge/node-dateformat
          if (!date) return
          // firestore TimeStamp
          if (typeof date.toDate !== 'undefined') {
            return dateFormat(date.toDate(), format)
          }
          let formatedDate
          try {
            formatedDate = dateFormat(date, format)
          } catch (e) {
            console.error(e, date)
            return ''
          }
          return formatedDate
        },
        dateIntFormat: function (dateInt) {
          if (!dateInt) {
            return
          }
          let dateString = dateInt.year + '年'
          if (dateInt.month) {
            dateString += dateInt.month + '月'
          }
          if (dateInt.day) {
            dateString += dateInt.day + '日'
          }
          return dateString
        },
        toFullPath: function (path) {
          return SITE_URL + path
        },
        dateIntToObject: function (dateInt) {
          if (Object.prototype.toString.call(dateInt) === '[object Date]') {
            return dateInt
          }
          if (dateInt.year && dateInt.month && dateInt.day) {
            const monthIndex = dateInt.month - 1
            return new Date(dateInt.year, monthIndex, dateInt.day)
          }
        },
        calcAge: function (birthDate, targetDate) {
          if (!targetDate) {
            targetDate = new Date()
          }
          birthDate = this.dateIntToObject(birthDate)
          if (!birthDate) { return '' }
          const diff = new Date(targetDate.getTime() - birthDate.getTime())
          const result = Math.abs(diff.getUTCFullYear() - 1970)
          if (isNaN(result)) {
            return ' '
          }
          return result
        },
        displayConsultationStatus: function (requestStatus) {
          const statusList = {
            creating: '作成中',
            applying: '申請中',
            confirmed: '承認済み',
            unconfirmed: '申請拒否',
            deleted: '削除済み'
          }
          return statusList[requestStatus]
        }
      }
    })
    Vue.prototype.$planConfig = main
  }
}

export default planConfig
